var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSubjectMatter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4395 16.744C2.03534 16.744 1.6235 17.0953 1.6235 17.44V17.68C1.6235 18.0769 1.97438 18.376 2.4395 18.376H12.4681V19.624H2.43998C1.2827 19.624 0.375977 18.7701 0.375977 17.68V2.67998C0.375977 1.40942 1.46318 0.375977 2.79998 0.375977H14.1995C14.365 0.375977 14.5237 0.441719 14.6407 0.558742C14.7578 0.675765 14.8235 0.834482 14.8235 0.999977V7.01294H13.5755V1.62398H2.7995C2.1515 1.62398 1.6235 2.09774 1.6235 2.67998V15.6673C1.88094 15.5551 2.15865 15.4968 2.4395 15.496H11.3387V16.744H2.4395Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6134 12.2322C19.6048 11.2122 19.1814 10.1854 18.4518 9.41167C18.0869 9.01958 17.6483 8.70329 17.161 8.4809C16.6738 8.25852 16.1474 8.13441 15.6121 8.11567V8.11279H15.4653V8.11567C14.93 8.13441 14.4036 8.25852 13.9164 8.4809C13.4291 8.70329 12.9905 9.01958 12.6256 9.41167C11.8945 10.1854 11.4736 11.2122 11.464 12.2322C11.3901 13.0693 11.6862 13.9448 12.3232 14.767C12.8473 15.487 13.4464 16.413 13.4464 17.1819V17.8059H17.632V17.1819C17.632 16.4139 18.231 15.4885 18.7552 14.767C19.3907 13.9448 19.6873 13.0693 19.6134 12.2322ZM17.7625 14.0082L17.7505 14.024C17.2 14.781 16.6393 15.6522 16.4502 16.557H14.6262C14.4371 15.6522 13.8765 14.781 13.3259 14.024L13.3139 14.0082C13.0009 13.6054 12.6419 12.9867 12.7081 12.3243L12.711 12.2931V12.2619C12.711 10.8814 13.8433 9.40447 15.5377 9.36271C17.2321 9.40447 18.3645 10.8814 18.3645 12.2619V12.2931L18.3673 12.3243C18.4345 12.9877 18.0755 13.6054 17.7625 14.0082Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4025 18.376H13.6681V19.624H17.4025V18.376Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSubjectMatter);
export default __webpack_public_path__ + "static/media/icon-subject-matter.85756ce68d0c97113f5e19aad23b0c0c.svg";
export { ForwardRef as ReactComponent };